export const validation = {
  fullName: "Please enter your full name",
  displayName: "Please enter your display name",
  validFullName: "Please enter valid full name",
  maxFullname: "Full name should not be more than 20 characters",
};
